import {useState} from "react";

export const useModalsSubscriptionExpired = () => {

    const [visibleModalLogout, setVisibleModalLogout] = useState<boolean>(false);

    return {
        visibleModalLogout, setVisibleModalLogout
    }
}
